module.exports = __webpack_public_path__ + "img/icon-r-heatmap-active.420252d1.svg";